import React from 'react';

import styles from './CapabilityResultsChart.module.scss';

const LegendItem = ({ capabilityElement }) => {
  return (
    <div className={styles['legend-item']}>
      <div className={styles['legend-item-marker']}>
        <svg width="12" height="24" viewBox="0 0 14 24">
          <g className={`palette-chart-${capabilityElement.paletteIndex}`}>
            <rect
              x="3"
              y="1"
              width="6"
              height="22"
              rx="3"
              ry="3"
              className="palette-fill range-span"
            />
            <circle cx={6} cy={12} r={6} className="palette-fill" />
            <circle cx={6} cy={12} r={3} className="post-hole" />
          </g>
        </svg>
      </div>
      <div className={styles['legend-item-name']}>{capabilityElement.name}</div>
    </div>
  );
};

export default LegendItem;
